import { render, staticRenderFns } from "./HeritageDetailOverall.vue?vue&type=template&id=5b968759&"
import script from "./HeritageDetailOverall.vue?vue&type=script&lang=js&"
export * from "./HeritageDetailOverall.vue?vue&type=script&lang=js&"
import style0 from "./HeritageDetailOverall.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports